import produce from 'immer';
import * as _ from 'underscore';

import { createReducer } from '../utils';

import * as Actions from './actions';

const reducer = createReducer(
  {
    freeFilterEnabled: false,
    premiumFilterEnabled: false,
    premiumSeatFilterEnabled: false,
    premiumSeat2FilterEnabled: false,
    premiumComplianceFilterEnabled: false,
    premiumCompSecFilterEnabled: false,
    contributorCountFilterEnabled: false,
    customBillingFilterEnabled: false,
    andOrToggle: false,
    contributorCountRange: {
      min: 0,
      max: 999999,
    },
    projectCountFilterEnabled: false,
    projectCountRange: {
      min: 0,
      max: 10000,
    },
    lastScannedTimeFilterEnabled: false,
    lastScannedTimeRange: {
      min: 0,
      max: 10000,
    },
    orgTextFilter: null,
    userTextFilter: null,
    orgs: {
      selectedOrg: null,
      delete: {
        status: {
          loading: false,
        },
      },
      entities: {},
      fetchMany: {
        status: {
          loading: false,
          errors: [],
        },
      },
    },
    migrations: {
      licenseCacheSplit: {
        status: {
          loading: false,
          errors: [],
        },
      },
    },
  },
  {
    [Actions.SET_ORG_TEXT_FILTER]: (state, action) => {
      return produce(state, draftState => {
        draftState.orgTextFilter = action.filter;
      });
    },
    [Actions.TOGGLE_FREE_FILTER]: (state) => {
      return produce(state, draftState => {
        draftState.freeFilterEnabled = !state.freeFilterEnabled;
      });
    },
    [Actions.TOGGLE_PREMIUM_FILTER]: (state) => {
      return produce(state, draftState => {
        draftState.premiumFilterEnabled = !state.premiumFilterEnabled;
      });
    },
    [Actions.TOGGLE_PREMIUM_SEAT_FILTER]: (state) => {
      return produce(state, draftState => {
        draftState.premiumSeatFilterEnabled = !state.premiumSeatFilterEnabled;
      });
    },
    [Actions.TOGGLE_PREMIUM_SEAT2_FILTER]: (state) => {
      return produce(state, draftState => {
        draftState.premiumSeat2FilterEnabled = !state.premiumSeat2FilterEnabled;
      });
    },
    [Actions.TOGGLE_PREMIUM_COMPLIANCE_FILTER]: (state) => {
      return produce(state, draftState => {
        draftState.premiumComplianceFilterEnabled = !state.premiumComplianceFilterEnabled;
      });
    },
    [Actions.TOGGLE_PREMIUM_COMP_SEC_FILTER]: (state) => {
      return produce(state, draftState => {
        draftState.premiumCompSecFilterEnabled = !state.premiumCompSecFilterEnabled;
      });
    },
    [Actions.TOGGLE_CONTRIBUTOR_COUNT_FILTER]: (state) => {
      return produce(state, draftState => {
        draftState.contributorCountFilterEnabled = !state.contributorCountFilterEnabled;
      });
    },
    [Actions.TOGGLE_PROJECT_COUNT_FILTER]: (state) => {
      return produce(state, draftState => {
        draftState.projectCountFilterEnabled = !state.projectCountFilterEnabled;
      });
    },
    [Actions.TOGGLE_AND_OR]: (state) => {
      return produce(state, draftState => {
        draftState.andOrToggle = !state.andOrToggle;
      });
    },
    [Actions.TOGGLE_CUSTOM_BILLING_FILTER]: (state) => {
      return produce(state, draftState => {
        draftState.customBillingFilterEnabled = !state.customBillingFilterEnabled;
      });
    },
    [Actions.SET_CONTRIBUTOR_COUNT_FILTER]: (state, action) => {
      return produce(state, draftState => {
        const { min, max } = action.range;
        draftState.contributorCountRange.min = min;
        draftState.contributorCountRange.max = max;
      });
    },
    [Actions.SET_PROJECT_COUNT_FILTER]: (state, action) => {
      return produce(state, draftState => {
        const { min, max } = action.range;
        draftState.projectCountRange.min = min;
        draftState.projectCountRange.max = max;
      });
    },
    [Actions.SET_SELECTED_ORG]: (state, action) => {
      return produce(state, draftState => {
        draftState.orgs.selectedOrg = action.org ? action.org.id : null;
      });
    },
    [`${Actions.FETCH_ORGS}_PENDING`]: (state) => {
      return produce(state, draftState => {
        draftState.orgs.fetchMany.status.loading = true;
      });
    },
    [`${Actions.FETCH_ORGS}_REJECTED`]: (state) => {
      return produce(state, draftState => {
        draftState.orgs.fetchMany.status.loading = false;
      });
    },
    [`${Actions.FETCH_ORGS}_FULFILLED`]: (state, action) => {
      return produce(state, draftState => {
        draftState.orgs.fetchMany.status.loading = false;
        draftState.orgs.entities = _.indexBy(action.payload.data || [], org => org.id);// action.payload.data || {};

        // check to see if the selected org is not in the new list
        const { selectedOrg } = draftState.orgs;
        if (selectedOrg && !draftState.orgs.entities[selectedOrg]) {
          draftState.orgs.selectedOrg = null;
        }
      });
    },
    [`${Actions.START_LICENSE_CACHE_MIGRATION}_PENDING`]: (state) => {
      return produce(state, draftState => {
        draftState.migrations.licenseCacheSplit.loading = true;
      });
    },
    [`${Actions.START_LICENSE_CACHE_MIGRATION}_REJECTED`]: (state) => {
      return produce(state, draftState => {
        draftState.migrations.licenseCacheSplit.loading = false;
      });
    },
    [`${Actions.START_LICENSE_CACHE_MIGRATION}_FULFILLED`]: (state) => {
      return produce(state, draftState => {
        draftState.migrations.licenseCacheSplit.loading = false;
      });
    },

    [`${Actions.DELETE_ORG}_PENDING`]: (state) => {
      return produce(state, draftState => {
        draftState.orgs.delete.status.loading = true;
      });
    },
    [`${Actions.DELETE_ORG}_REJECTED`]: (state, action) => {
      return produce(state, draftState => {
        draftState.orgs.delete.status.loading = false;
        draftState.orgs.delete.status.error = true;
        draftState.orgs.delete.status.code = action.payload.status;
      });
    },
    [`${Actions.DELETE_ORG}_FULFILLED`]: (state) => {
      return produce(state, draftState => {
        draftState.orgs.delete.status.loading = false;
        if (draftState.orgs.selectedOrg) {
          delete draftState.orgs.entities[draftState.orgs.selectedOrg];
        }

        draftState.orgs.selectedOrg = null;
      });
    },
  },
);

export default reducer;
